import cloneDeep from 'lodash/cloneDeep';
import { toBase64, alertSwal } from '~/utils/helpers';

export class RequestBodyConverter {
    constructor(data) {
        this.data = cloneDeep(data);
    }

    async convertPictures(values, pictureAttributeNames) {
        try {
            await Promise.all(pictureAttributeNames.map(async (pic) => (this.data[pic] = await toBase64(values[pic]))));
        } catch (error) {
            alertSwal('error', 'There was error in processing card image.');
            console.log('🚀 ~ error:::RequestBodyConverter convertCommonPictures()', error);
        }
    }
}
